import styled, { css } from 'styled-components';
import {
  AnchoredAlert,
  Divider,
  Flex,
  Link,
  styleMixinFocusOutline,
} from '@amzn/storm-ui';

export const AllToolsSideNavLinkWrapper = styled.div`
  padding: '20px 40px',
  borderRadius: '8px',
  min-height: 40px;
  width: 296px;
  cursor: pointer;
`;

const sideNavLinkStyles = css<{ isSelected: boolean }>`
  box-sizing: border-box;
  gap: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text.color.default};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.border.radius.large};
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) =>
    theme.selectableContainer.backgroundColor.default};
  min-height: 40px;
  :hover,
  :focus-visible {
    background-color: ${({ theme }) =>
      theme.selectableContainer.backgroundColor.hover};
  }
`;

export const AllToolsNavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const AllToolsSideNavLinkInnerWrapper = styled(Link)<{
  isSelected: boolean;
}>`
  border-radius: ${({ theme }) => theme.border.radius.large};
  ${sideNavLinkStyles};
  padding: 0 ${({ theme }) => theme.spacing.xxsmall.default};
  &:link,
  &:visited {
    color: ${({ theme }) => theme.text.color.default};
    text-decoration: none;
  }

  &:hover,
  &:active,
  &:focus-visible {
    text-decoration: none;
    color: ${({ theme }) => theme.color.gray[800]};
    background-color: ${({ theme }) =>
      theme.selectableContainer.backgroundColor.hover};
  }
  &:focus-visible {
    ${styleMixinFocusOutline};
  }
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.selectableContainer.backgroundColor.hover};
      font-weight: 700;
    `};
`;

export const AccordionContentInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.xsmall.default};
  margin-inline-start: 0.5rem;
  padding-inline-start: ${({ theme }) => theme.spacing.base.default};
  border-inline-start: 2px solid
    ${({ theme }) => theme.border.color.subtle.default};
`;

export const AccordionContentGroupWrapper = styled(Flex)`
  box-sizing: border-box;
`;

export const AccordionContentSubTitle = styled.span`
  color: ${({ theme }) => theme.text.color.default};

  &&& {
    font-size: 12px;
  }

  font-weight: bold;
  line-height: 1.333;
  padding: ${({ theme }) =>
    `${theme.spacing.xxsmall.default} 0 ${theme.spacing.xxxsmall.default} ${theme.spacing.xxsmall.default}`};
  margin-bottom: ${({ theme }) => theme.spacing.xxsmall.default};
`;

export const StyledDivider = styled(Divider)`
  margin: 15px 12px 15px 0px;
  width: 90%;
`;

export const AccordionLinkWrapper = styled.div<{
  isSelected: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.text.color.default};
  text-decoration: none;
  border-radius: ${({ theme }) => theme.border.radius.large};
  cursor: pointer;
  border: none;
  background-color: ${({ theme }) =>
    theme.selectableContainer.backgroundColor.default};
  min-height: 40px;
  padding-inline: ${({ theme }) =>
    `${theme.spacing.xxsmall.default} ${theme.spacing.xsmall.default}`};
      :hover,
      :focus-visible {
        background-color: ${({ theme }) =>
          theme.selectableContainer.backgroundColor.hover};

  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.selectableContainer.backgroundColor.selected};
    `};
`;

export const AllToolsTitleWrapper = styled(Flex)`
  min-height: 40px;
  align-items: center;
`;

export const AllToolsAnchoredAlert = styled(AnchoredAlert)`
  z-index: 399 !important;
`;
